import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { MainToolbar } from './mainToolbar';
//import { SubToolbar } from './subToolbar';
import { Box, CircularProgress, Stack } from '@mui/material';
import TimelineItem from './elements/timelineItem';
import SpellContainer from './elements/spellContainer';
import EpisodeGroup from './elements/episodeGroup';
import { useSelector } from 'react-redux';
import { catalogDocuments, catalogAttendances, activeViewerWindow } from './store/documentViewerReducer';
import _ from 'lodash';
import moment from 'moment';
import { buildTab } from './store/methods';
import APIDocuments from './apiDocuments';
import { setLoading } from '../../store/reducers/ward';

class ITEM_KIND {
    // Private Fields
    static #_DATE_MARKER = 0;
    static #_DOCUMENT = 1;
    static #_EPISODE = 2;
    static #_SPELL = 3;

    // Accessors for "get" functions only (no "set" functions)
    static get DATE_MARKER() {
        return this.#_DATE_MARKER;
    }
    static get DOCUMENT() {
        return this.#_DOCUMENT;
    }
    static get EPISODE() {
        return this.#_EPISODE;
    }
    static get SPELL() {
        return this.#_SPELL;
    }
}

//maybe should be same as in API site
class DOCUMENT_KIND {
    // Private Fields
    static #_DOCUMENT = 0;
    static #_SPELL = 1;
    static #_ATTENDANCE = 2;
    static #_REFERRAL = 3;

    // Accessors for "get" functions only (no "set" functions)
    static get DOCUMENT() {
        return this.#_DOCUMENT;
    }
    static get SPELL() {
        return this.#_SPELL;
    }
    static get ATTENDANCE() {
        return this.#_ATTENDANCE;
    }
    static get REFERRAL() {
        return this.#_REFERRAL;
    }
}

const timelineDateFormat = 'DD/MM/YYYY, h:mm A';
const timelineDateFormatShort = 'DD/MM/YYYY';
const colorMarks = {
    base: [
        '#B00089',
        '#008CA1',
        '#28A745',
        '#E65100',
        '#F9A825',
        '#1A237E',
        '#F57C00',
        '#006064',
        '#D32F2F',
        '#1B5E20',
        '#4A148C',
        '#EC407A',
    ],
    dark: [
        '#D800A8',
        '#00BCD4',
        '#39FF14',
        '#FF6500',
        '#FFCC00',
        '#2E5BFF',
        '#FFA037',
        '#008080',
        '#FF0000',
        '#0A900A',
        '#6800BE',
        '#FDB8C1',
    ],
    light: [
        '#ef75b6',
        '#7ae4e8',
        '#7ae67f',
        '#f6925c',
        '#fad36f',
        '#5e71f8',
        '#fd5520',
        '#03a88c',
        '#c60c0c',
        '#398f18',
        '#8459b8',
        '#AD1457',
    ],
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        height: '100%',
        '& ::-webkit-scrollbar-thumb:hover': {
            background: `${theme.palette.documentViewer.lowContrastTextHoverColor} !important`,
        },
        '& ::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
        },
        '& ::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
        },
        '& ::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.documentViewer.lowContrastTextColor,
        },
    },
    timeline: {
        //scrollbarWidth: 'thin !important',
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingLeft: '15px',
    },
    dateMark: {
        marginLeft: '-7px',
        fontFamily: 'Inter',
        fontSize: '10px',
        fontStyle: 'normal',
        fontWeight: '500',
        paddingTop: '4px',
        paddingBottom: '4px',
    },
}));

const mock = {
    '12/12/2025': [
        {
            kind: DOCUMENT_KIND.DOCUMENT,
            id: '6698e1f03e796c00dc79820b',
            metadata: { pageCount: 11 },
            originalFilename: 'Guidances_2023.pdf',
            date: '12-12-2025T12:46:00Z',
            bookmarks: [],
        },
        {
            kind: DOCUMENT_KIND.SPELL,
            name: 'Spell ID 2344',
            startDate: moment('2023-12-10'),
            endDate: moment('2025-12-12'),
            nested: [
                {
                    kind: DOCUMENT_KIND.DOCUMENT,
                    docId: '6698e1f03e796c00dc79820b',
                    metadata: { pageCount: 8 },
                    originalFilename: 'test some_2023.pdf',
                    date: '09-12-2025T12:46:00Z',
                    bookmarks: [],
                },
                {
                    kind: DOCUMENT_KIND.ATTENDANCE,
                    name: 'Inpatient',
                    short: 'I',
                    startDate: moment('2025-11-24'),
                    endDate: moment('2025-12-05'),
                    nested: [
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            id: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 3 },
                            originalFilename: 'some_treatment1.pdf',
                            date: '05-12-2025T10:12:00Z',
                            bookmarks: [{ bkm: 'private' }],
                        },
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            id: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 1 },
                            originalFilename: 'some_treatment_with_some_extra_long_name.pdf',
                            date: '01-12-2025T10:12:00Z',
                            bookmarks: [{ bkm: 'private' }],
                        },
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            id: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 377 },
                            originalFilename: 'some_treatment_443.pdf',
                            date: '30-11-2025T10:12:00Z',
                            bookmarks: [{ bkm: 'private' }],
                        },
                    ],
                },
                {
                    kind: DOCUMENT_KIND.ATTENDANCE,
                    name: 'Inpatient',
                    short: 'I',
                    startDate: moment('2025-09-24'),
                    endDate: moment('2025-10-10'),
                    nested: [
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            id: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 5 },
                            originalFilename: 'some_treatment1.pdf',
                            date: '05-10-2025T10:12:00Z',
                            hasAlerts: true,
                        },
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            id: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 17 },
                            originalFilename: 'some_treatment_with_some_extra_long_name.pdf',
                            date: '29-09-2025T10:12:00Z',
                            comments: 5,
                        },
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            id: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 1 },
                            originalFilename: 'some_treatment_443.pdf',
                            date: '25-09-2025T10:12:00Z',
                            hasAlerts: true,
                            hiddenPages: 5,
                        },
                    ],
                },
                {
                    kind: DOCUMENT_KIND.ATTENDANCE,
                    name: 'Outpatient',
                    short: 'O',
                    startDate: moment('2025-09-06'),
                    endDate: moment('2025-09-10'),
                    nested: [
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            docId: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 5 },
                            originalFilename: 'some_treatment1.pdf',
                            date: '10-09-2025T10:12:00Z',
                            hasAlerts: true,
                            comments: 2,
                        },
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            docId: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 3 },
                            originalFilename: 'some_treatment_with_some_extra_long_name.pdf',
                            date: '09-09-2025T10:12:00Z',
                            hiddenPages: 1,
                            isFavorites: true,
                        },
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            docId: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 11 },
                            originalFilename: 'some_treatment_443.pdf',
                            date: '06-09-2025T18:10:00Z',
                        },
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            docId: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 11 },
                            originalFilename: 'some_treatment_443.pdf',
                            date: '06-09-2025T10:12:00Z',
                            hasAlerts: true,
                            hiddenPages: 5,
                        },
                    ],
                },
                {
                    kind: DOCUMENT_KIND.REFERRAL,
                    name: 'Referral test',
                    short: 'R',
                    startDate: moment('2023-12-01'),
                    endDate: moment('2023-12-10'),
                    nested: [
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            id: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 2 },
                            originalFilename: 'some_treatment1.pdf',
                            date: '10-12-2023T02:12:00Z',
                        },
                        {
                            kind: DOCUMENT_KIND.DOCUMENT,
                            id: '6698e1f03e796c00dc79820b',
                            metadata: { pageCount: 5 },
                            originalFilename: 'some_treatment_with_some_extra_long_name.pdf',
                            date: '01-12-2023T18:34:00Z',
                            comments: 5,
                            hasAlerts: true,
                            hiddenPages: 5,
                        },
                    ],
                },
            ],
        },
    ],
    '20/01/2022': [
        {
            kind: DOCUMENT_KIND.DOCUMENT,
            id: '6698e1f03e796c00dc79820b',
            metadata: { pageCount: 3 },
            originalFilename: 'some_treatment1.pdf',
            date: '12-01-2022T06:15:00Z',
            bookmarks: [{ bkm: 'private' }],
        },
        {
            kind: DOCUMENT_KIND.DOCUMENT,
            id: '6698e1f03e796c00dc79820b',
            metadata: { pageCount: 5 },
            originalFilename: 'some_treatment_with_some_extra_long_name.pdf',
            date: '12-01-2022T10:52:00Z',
        },
        {
            kind: DOCUMENT_KIND.DOCUMENT,
            id: '6698e1f03e796c00dc79820b',
            metadata: { pageCount: 7 },
            originalFilename: 'some_treatment_443.pdf',
            date: '12-01-2022T14:55:00Z',
            hasAlerts: true,
        },
    ],
    '25/01/2021': [
        {
            kind: DOCUMENT_KIND.DOCUMENT,
            id: '6698e1f03e796c00dc79820b',
            metadata: { pageCount: 3 },
            originalFilename: 'some_treatment1.pdf',
            date: '12-01-2021T16:15:00Z',
            bookmarks: [{ bkm: 'private' }],
        },
        {
            kind: DOCUMENT_KIND.ATTENDANCE,
            name: 'Outpatient',
            short: 'O',
            startDate: moment('2021-01-25'),
            endDate: moment('2021-01-25'),
            nested: [
                {
                    kind: DOCUMENT_KIND.DOCUMENT,
                    id: '6698e1f03e796c00dc79820b',
                    metadata: { pageCount: 5 },
                    originalFilename: 'some_treatment1.pdf',
                    date: '25-01-2021T09:16:00Z',
                    hasAlerts: true,
                    comments: 2,
                },
                {
                    kind: DOCUMENT_KIND.DOCUMENT,
                    id: '6698e1f03e796c00dc79820b',
                    metadata: { pageCount: 3 },
                    originalFilename: 'some_treatment_with_some_extra_long_name.pdf',
                    date: '25-01-2021T13:34:00Z',
                    hiddenPages: 1,
                    isFavorites: true,
                },
            ],
        },
    ],
};

const mockAnnotations = [
    {
        _id: 'annotationmock1',
        type: 'string',
        color: 'string',
        anchorX: 0,
        anchorY: 0,
        rectX: 0,
        rectY: 0,
        rectWidth: 0,
        rectHeight: 0,
        text: 'MOCK Figma ipsum component variant main layer. Strikethrough link outline link line move comment outline. Outline move layer link clip horizontal. Fill star font edit scrolling flows. Slice text bold thumbnail boolean effect layer bullet star library.',
        page: 1,
        user_id: 'Dr Martin Hall',
        createdDate: '2026-04-17T12:48:37.884Z',
        lastModifiedDate: '2026-04-12T12:48:37.884Z',
        opacity: 0,
        rotation: 0,
        stamp_id: 0,
        comments: [
            {
                _id: 'cmt1',
                text: 'Comment text for some annotation',
                originalText: 'string',
                user_id: 'Dr Steffen Beera',
                createdDate: '2026-04-17T12:48:37.884Z',
                lastModifiedDate: '2026-04-17T12:48:37.884Z',
            },
        ],
    },
    {
        _id: 'annotationmock2',
        type: 'string',
        color: 'string',
        anchorX: 0,
        anchorY: 0,
        rectX: 0,
        rectY: 0,
        rectWidth: 0,
        rectHeight: 0,
        text: 'MOCK Figma ipsum component variant main layer. Strikethrough link outline link line move comment outline.',
        page: 29,
        user_id: 'Dr Steffen Beera',
        createdDate: '2026-04-11T09:15:37.884Z',
        lastModifiedDate: '2026-04-11T09:15:37.884Z',
        opacity: 0,
        rotation: 0,
        stamp_id: 0,
        comments: [
            {
                _id: 'cmt2',
                text: 'string',
                originalText: 'string',
                user_id: 'Dr Martin Hall',
                createdDate: '2026-04-12T09:37:37.884Z',
                lastModifiedDate: '2026-04-12T09:37:37.884Z',
            },
        ],
    },
];

const mockBookmarks = [
    {
        id: 'bookmarkmock1',
        href: 'string',
        isPublic: true,
        pageNumber: 1,
        name: 'string',
        note: 'Lorem Ipsum random text first line.\n' + 'Lorem Ipsum random text second line.  ',
        userName: 'string',
        userFirstName: 'Dr Martin Hall',
        userLastName: '',
        specialties: [
            {
                additionalProp1: {},
            },
        ],
        createdDate: '2026-04-16T12:48:37.884Z',
        endDate: '2026-04-16T12:34:53.672Z',
    },
];

export function DocumentViewTimeline(props) {
    const classes = useStyles();
    const documents = useSelector(catalogDocuments);
    const attendances = useSelector(catalogAttendances);
    // const spells = useSelector(catalogSpells);
    // const episodes = useSelector(catalogEpisodes);

    const activeViewerWindowIdx = useSelector(activeViewerWindow);
    const [timelineDataItems, setTimelineDataItems] = React.useState([]);
    const [timelineDomElements, setTimelineDomElements] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    //timeline build view according allDocuments (on effect all documents has been set)
    //connect all opened and active(selected)

    React.useEffect(() => {
        if (documents !== undefined && attendances !== undefined) {
            setLoading(true);
            //TODO: here should be mixing all of kind of items and set to groups according to rules
            setTimelineDataItems(buildTimelineData(buildDataTree([...documents, ...attendances])));
            // console.log('dv attendances', attendances);
        } else {
            setTimelineDataItems(buildTimelineData(mock));
        }
    }, [documents, attendances]);

    React.useEffect(() => {
        setLoading(false);
        setTimelineDomElements(buildItems(timelineDataItems));
    }, [timelineDataItems]);

    React.useEffect(() => {
        let domElCopy = _.cloneDeep(timelineDomElements);
        domElCopy.filter((tItem) => tItem.props.selected).forEach((tItem) => (tItem.props.selected = false));
        domElCopy.filter((tItem) => tItem.props.opened).forEach((tItem) => (tItem.props.opened = false));
        if (props.openedTabIds.length > 0) {
            const docsCurrentlyOpen = props.openedTabIds.map((tId) => tId.replace('tab_', ''));
            domElCopy.filter((tItem) => docsCurrentlyOpen.indexOf(tItem.props.docId) > -1).forEach((tItem) => (tItem.props.opened = true));
            const currentSelectedTab = props.selectedTabs[activeViewerWindowIdx];
            if (currentSelectedTab !== undefined) {
                const currentDocId = currentSelectedTab.replace('tab_', '');
                const selectedDomIdx = _.findIndex(timelineDomElements, (tItem) => tItem.props.docId === currentDocId);
                if (domElCopy[selectedDomIdx]) domElCopy[selectedDomIdx].props.selected = true;
            }
        }
        setTimelineDomElements(domElCopy);
    }, [props.openedTabIds, props.selectedTabs]);

    const clickOpenDocument = (documentId) => {
        const document = _.find(documents, (d) => d.id === documentId);
        if (document !== undefined) {
            APIDocuments.getDocAnnotations(documentId).then(
                (annotations) => {
                    let docTmp = _.cloneDeep(document);
                    docTmp.bookmarks = _.cloneDeep(mockBookmarks);
                    props.selectTab(buildTab(docTmp, [...annotations, ...mockAnnotations]));
                },
                (error) => {
                    console.log('error getting annotations', error);
                    props.selectTab(buildTab(document, []));
                },
            );
        }
    };

    //TODO: NEED TO ADD, referrals, attendances, spells - MAIN LOGIC
    const buildDataTree = (instanceObjects) => {
        //let spells = _.filter(attendances, (attn) => _.get(attn, 'metadata.episodes', []).length > 0);
        let childDocs = _.remove(instanceObjects, (doc) => {
            if (doc.src != 'attendances') {
                const docAttnd = _.get(doc, 'metadata.attendanceId', null);
                return !_.isNull(docAttnd) && docAttnd.length > 0;
            }
            return false; /// maybe something else?
        });

        const gr = _.groupBy(instanceObjects, (d) => {
            return moment(d.date).format('DD/MM/YYYY');
        });
        const dateStamps = _.reverse(Object.keys(gr).sort((keyDate) => moment(keyDate, 'DD/MM/YYYY').unix()));
        let treeOfItems = {};
        dateStamps.forEach((dateStamp) => {
            let docItems = [];
            const docs = _.get(gr, dateStamp, []);
            docs.forEach((doc) => {
                if (doc.src == 'attendances') {
                    const attnId = _.get(doc, 'metadata.attendanceId', 'unknown');
                    let attnNestedDocs = _.remove(childDocs, (doc) => _.get(doc, 'metadata.attendanceId', '--') == attnId);
                    docItems.push({
                        kind: DOCUMENT_KIND.ATTENDANCE,
                        name: _.get(doc, 'metadata.attendanceType', 'Attendance'),
                        short: _.get(doc, 'metadata.attendanceTypeId', '-'),
                        startDate: moment(doc.date),
                        endDate: null,
                        nested: _.isNull(attnNestedDocs) ? [] : attnNestedDocs,
                        metadata: _.get(doc, 'metadata', {}),
                    });
                } else {
                    docItems.push({
                        kind: DOCUMENT_KIND.DOCUMENT,
                        ...doc,
                    });
                }
            });
            _.set(treeOfItems, dateStamp, docItems);
        });
        return treeOfItems;
    };

    //MAPPER SUBFUNCTIONS
    const buildTimelineSpellContainerProps = (spellData, nested = []) => {
        let timelineProp = {
            kind: ITEM_KIND.SPELL,
            key: `timeline-${_.uniqueId('spell-item')}-${_.get(spellData, 'id', _.uniqueId('spellData_'))}`,
            defaultExpanded: true, //maybe set inside some system defaults or user defaults
        };
        const name = _.get(spellData, 'name'); //TODO:connect property
        if (!_.isEmpty(name)) timelineProp.name = name;
        const startDate = _.get(spellData, 'startDate', null); //TODO:connect property
        if (!_.isNull(startDate) && moment.isMoment(startDate)) timelineProp.startDate = startDate.format(timelineDateFormatShort);
        const endDate = _.get(spellData, 'endDate', null); //TODO:connect property
        if (!_.isNull(endDate) && moment.isMoment(endDate)) timelineProp.endDate = endDate.format(timelineDateFormatShort);
        let children = [];
        let episodes = 0;
        _.forEach(nested, (item) => {
            const kind = _.get(item, 'kind', DOCUMENT_KIND.DOCUMENT);
            switch (kind) {
                case DOCUMENT_KIND.DOCUMENT:
                    children.push(buildTimelineItemProps(item));
                    break;
                case DOCUMENT_KIND.ATTENDANCE:
                case DOCUMENT_KIND.REFERRAL:
                    children.push(buildTimelineEpisodeGroupProps(item, item.nested, episodes));
                    episodes++;
                    break;
                case DOCUMENT_KIND.SPELL:
                    children.push(buildTimelineSpellContainerProps(item, item.nested));
                    break;
                default:
                    console.log('missing item kind property', item);
            }
        });
        if (children.length > 0) timelineProp.children = children;
        return timelineProp;
    };

    const buildTimelineEpisodeGroupProps = (episodeData, nested = [], key = 0) => {
        const theme = window._getTheme();
        const colorArray = _.get(colorMarks, theme, colorMarks.base);
        const idx = key % colorArray.length;
        let timelineProp = {
            kind: ITEM_KIND.EPISODE,
            key: `timeline-${_.uniqueId('episode-item')}-${_.get(episodeData, 'id', _.uniqueId('episodeData_'))}`,
            color: colorArray[idx],
            defaultExpanded: true, //maybe set inside some system defaults or user defaults
        };
        const name = _.get(episodeData, 'name'); //TODO:connect property
        if (!_.isEmpty(name)) timelineProp.name = name;
        const short = _.get(episodeData, 'short'); //TODO:connect property
        if (!_.isEmpty(short)) timelineProp.short = short;
        const startDate = _.get(episodeData, 'startDate', null); //TODO:connect property
        if (!_.isNull(startDate) && moment.isMoment(startDate)) timelineProp.startDate = startDate.format(timelineDateFormatShort);
        const endDate = _.get(episodeData, 'endDate', null); //TODO:connect property
        if (!_.isNull(endDate) && moment.isMoment(endDate)) timelineProp.endDate = endDate.format(timelineDateFormatShort);
        if (_.get(episodeData, 'documentKind') === DOCUMENT_KIND.REFERRAL) timelineProp.showAttachCoun = true; //TODO: check what to do with that
        let children = [];
        _.forEach(nested, (item) => {
            const kind = _.get(item, 'kind', DOCUMENT_KIND.DOCUMENT);
            switch (kind) {
                case DOCUMENT_KIND.DOCUMENT:
                    children.push(buildTimelineItemProps(item, colorArray[idx]));
                    break;
                case DOCUMENT_KIND.ATTENDANCE:
                case DOCUMENT_KIND.REFERRAL:
                    children.push(buildTimelineEpisodeGroupProps(item, item.nested, idx + 1));
                    break;
                case DOCUMENT_KIND.SPELL:
                    children.push(buildTimelineSpellContainerProps(item, item.nested));
                    break;
                default:
                    console.log('missing item kind property', item);
            }
        });
        timelineProp.children = children;
        return timelineProp;
    };

    const buildTimelineItemProps = (document, colorMark = undefined) => {
        let timelineProps = {
            kind: ITEM_KIND.DOCUMENT,
            key: `timeline-${_.uniqueId('doc-item')}-${_.get(document, 'id', _.uniqueId('document_'))}`,
            docId: _.get(document, 'id', _.uniqueId('document_')),
            selected: false,
            opened: false,
            pageCount: _.get(document, 'metadata.pageCount', 0),
            fileName: _.get(document, 'originalFilename', '-'),
            onSelect: clickOpenDocument,
        };
        const docDate = moment(document.date, 'YYYY-MM-DDThh:mm:ssZ');
        if (docDate && moment.isMoment(docDate)) {
            _.set(timelineProps, 'fileDate', docDate.format(timelineDateFormat));
        }
        let bookmarks = _.get(document, 'bookmarks', []);
        if (bookmarks && Array.isArray(bookmarks)) {
            _.set(timelineProps, 'bookmarks', bookmarks.length);
        }
        if (colorMark) {
            timelineProps.colorMark = colorMark;
        }

        //TODO: connect with proper fields
        timelineProps.hasBookmark = _.get(document, 'hasBookmark', false);
        timelineProps.isFavorite = _.get(document, 'isFavorite', false);
        timelineProps.hasAlerts = _.get(document, 'hasAlerts', false);
        timelineProps.comments = _.get(document, 'comments', 0);
        timelineProps.hiddenPages = _.get(document, 'hiddenPages', 0);
        /*
        hasBookmark: PropTypes.bool,
        isFavorite: PropTypes.bool,
        hasAlerts: PropTypes.bool,
        comments: PropTypes.number,
        hiddenPages: PropTypes.number,
         */
        return timelineProps;
    };
    //END OF MAPPER SUBFUNCTIONS

    //MAPPER for all elements, mapping data to properties for components
    const buildTimelineData = (tree) => {
        const dateMarkers = Object.keys(tree);
        let arrayOfItems = [];
        let idxColorMarker = -1;
        _.forEach(dateMarkers, (marker) => {
            arrayOfItems.push({
                kind: ITEM_KIND.DATE_MARKER,
                date: marker,
                key: `timeline-date-mark-${moment(marker, 'DD/MM/YYYY').unix()}`,
            });
            _.forEach(tree[marker], (item) => {
                const kind = _.get(item, 'kind', -1);
                switch (kind) {
                    case DOCUMENT_KIND.DOCUMENT:
                        arrayOfItems.push(buildTimelineItemProps(item));
                        break;
                    case DOCUMENT_KIND.ATTENDANCE:
                    case DOCUMENT_KIND.REFERRAL:
                        arrayOfItems.push(buildTimelineEpisodeGroupProps(item, item.nested, idxColorMarker + 1));
                        break;
                    case DOCUMENT_KIND.SPELL:
                        arrayOfItems.push(buildTimelineSpellContainerProps(item, item.nested));
                        break;
                    default:
                        console.log('missing item kind property', item);
                }
            });
        });
        return arrayOfItems;
    };

    //BUILDER FOR TREE VIEW!
    const buildItems = (itemsTree) => {
        let componentsList = [];
        itemsTree.forEach((item) => {
            switch (item.kind) {
                case ITEM_KIND.DATE_MARKER:
                    componentsList.push(
                        <Box className={classes.dateMark} {...item}>
                            {item.date}
                        </Box>,
                    );
                    break;
                case ITEM_KIND.DOCUMENT:
                    componentsList.push(<TimelineItem {...item} onSelect={clickOpenDocument} />);
                    break;
                case ITEM_KIND.EPISODE:
                    componentsList.push(<EpisodeGroup {...item}>{buildItems(item.children)}</EpisodeGroup>);
                    break;
                case ITEM_KIND.SPELL:
                    componentsList.push(<SpellContainer {...item}>{buildItems(item.children)}</SpellContainer>);
                    break;
                default:
                    componentsList.push(<Box>Incorrect item</Box>);
            }
        });
        return componentsList;
    };

    return (
        <Stack className={classes.root}>
            <Box>
                <MainToolbar viewerId={props.viewerId} />
                {/*<SubToolbar viewerId={props.viewerId} />*/}
            </Box>
            <Stack direction={'column'} padding={'5px'} gap={'5px'} className={classes.timeline}>
                {loading && <CircularProgress />}
                {!loading && timelineDomElements}
            </Stack>
        </Stack>
    );
}
